import React, { ReactElement } from 'react';
import { useKakaoLogin } from '@hooks/auth';
import { Button } from 'antd';

interface LoginFormProps {
  showLoading?: boolean;
  extra?: string | ReactElement;
  loading?: boolean;
  showMessage?: string;
  message?: string;
}

const KakaoLogin = (props: LoginFormProps) => {
  const kakaoLogin = useKakaoLogin();

  const handleOnClickKakaoLogin = async (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();

    kakaoLogin();
  };

  return (
    <div className="d-flex justify-content-center">
      <Button
        type="default"
        size="large"
        onClick={handleOnClickKakaoLogin}
        style={{
          width: '100%',
          maxWidth: '400px',
          height: '56px',
          backgroundColor: '#FEE500',
          borderColor: '#FEE500',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 500,
          color: '#000000',
          position: 'relative',
          padding: 0,
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '32px',
            height: '32px',
            backgroundColor: '#ffffff',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="/img/icons/kakao-login.png"
            alt="Kakao"
            style={{ width: '30px', height: '30px' }}
          />
        </div>
        <div
          style={{
            width: '100%',
            textAlign: 'center',
          }}
        >
          카카오 계정으로 로그인 하기
        </div>
      </Button>
    </div>
  );
};

export default KakaoLogin;
